"use client"

import React from "react"

import { cn } from "@/lib/utils"
import { Button, RemixIcon } from "@/components/ui/atoms"

type TArticleShareProps = {
  copyAction?: () => void
  sharedString: string
  urlShare: string
}

const share = [
  {
    label: "Facebook",
    icon: "Facebook",
    href: "https://www.facebook.com/sharer/sharer.php?u=",
  },
  {
    label: "Whatsapp",
    icon: "Whatsapp",
    href: "https://wa.me/?text=",
    mobileOnly: true,
  },
]

const ArticleShare = ({
  copyAction,
  sharedString,
  urlShare,
}: TArticleShareProps) => {
  return (
    <div className="article-share flex flex-wrap items-center">
      <h4 className="label-m mb-5 mr-7">{sharedString}</h4>
      <div className="mb-5 flex gap-6 sm:gap-7">
        {share.map((item) => {
          return (
            <Button
              key={item.label}
              variant="primary"
              className={cn(
                "baseButton--icon",
                item.mobileOnly ? "md:hidden" : ""
              )}
              asChild
            >
              <a
                href={`${item.href}${urlShare}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <RemixIcon name={item.icon} size="md" />
                <span className="sr-only">{item.label}</span>
              </a>
            </Button>
          )
        })}
        <Button
          variant="primary"
          iconRight="Link"
          className="js-copyLink"
          onClick={copyAction}
        />
      </div>
    </div>
  )
}

export { ArticleShare, type TArticleShareProps }
